import { ObjectValues } from 'types';

export const ERROR_TYPES = {
  NO_CONTACT_NUMBER: 101,
  NO_VERIFIED_MAIL: 102,
  INVALID_CAPTCHA: 103,
  UNAUTHORIZED_FOR_ACTION: 104,
  RESOURCE_ACCESS_UNAUTHORIZED: 105,
  INVALID_RESOURCE_ID: 106,
  JWT_UNAUTHORIZED: 107,
  INVALID_JWT_TOKEN: 108,
  STRIPE_AUTHORIZATION_MIDDLEWARE: 109,
  ACCOUNT_WITH_EMAIL_OR_PHONE_NUMBER_EXIST: 110,
  UNAUTHORIZED_MESSAGE_ACCESS: 111,
  UNAUTHORIZED_SESSION_ACCESS: 112,
  UNAUTHORIZED_COMPANY_ACCESS: 113,
  UNAUTHORIZED_LISTING_ACCESS: 114,
  UNAUTHORIZED_LISTING_ENQUIRY_ACCESS: 115,
  UNAUTHORIZED_LEAD_ACCESS: 116,
  UNAUTHORIZED_NOTIFICATION_ACCESS: 117,
  REFRESH_TOKEN_EXPIRED: 118,
  BAD_BODY_VALIDATION_ERROR: 119,
  INVALID_CREDENTIALS: 120,
  SOCIAL_LOGIN_USER_CANT_RETRIEVED: 121,
  MISSING_FILE: 122,
  MISSING_FILENAME: 123,
  INVALID_FILENAME: 124,
  INVALID_MIMETYPE: 125,
  TWILIO_WRONG_CODE: 126,
  INVALID_VALUE_FOR_STEP: 127,
  LISTING_WITH_CONTROLLED_INFORMATION_EXIST: 128,
  CAN_CONFIRM_INTEREST_FROM_ACCEPTED_STATE: 129,
  CAN_ACCEPT_OFFER_FROM_OFFERED_LEAD_STATE: 130,
  CAN_REJECT_OFFER_FROM_OFFERED_LEAD_STATE: 131,
  UNEXPECTED_LEAD_STATE_OPTION: 132,
  BAD_LEAD_STATE_TRANSITION: 133,
  NEW_LEAD_STATE_IS_FULL: 134,
  CANT_SEND_DELETE_ACCOUNT_REQUEST: 135,
  PHONE_NUMBER_VERIFIED: 136,
  EXIST_LEAD_FOR_LISTING_ENQUIRY: 137,
  RESOURCE_NOT_FOUND: 138,
  USER_DOCUMENT_NOT_FOUND: 139,
  CHAT_MESSAGE_NOT_FOUND: 140,
  USER_CONNECTION_NOT_FOUND: 141,
  CHAT_SESSION_NOT_FOUND: 142,
  CHAT_PARTICIPANT_NOT_FOUND: 143,
  FILE_NOT_FOUND: 144,
  COMPANY_NOT_FOUND: 145,
  LISTING_NOT_FOUND: 146,
  LISTING_ENQUIRY_NOT_FOUND: 147,
  WORKFLOW_CONFIGURATION_NOT_FOUND: 148,
  LISTING_INVOICE_NOT_FOUND: 149,
  LISTING_SUBSCRIPTION_NOT_FOUND: 150,
  NOTIFICATION_NOT_FOUND: 151,
  CANNOT_MAKE_ENQUIRY: 152,
  LEAD_NOT_FOUND: 153,
  INVALID_API_KEY: 154,
  FILE_NAME_TOO_LONG: 155,
  FILE_UPLOAD_FAILED: 156,
  FILE_CORRUPTED: 157,
  NEED_SOCIAL_LOGIN: 158,
  PHONE_VERIFICATION_LIMIT_EXCEEDED: 159,
  BROKER_DOESNT_HAVE_COMPANY: 160,
  EXTERNAL_LEAD_EXIST: 161,
  SPONSORED_LISTING_NOT_FOUND: 162,
  BROKER_EXISTS: 163,
  // 164 is not using anymore
  DUPLICATE_CUSTOM_FILE_NAME: 165,
  WRONG_ENVELOPE_TEMPLATE_ID: 166,
  ACCOUNTANT_NOT_FOUND: 167,
  CANNOT_CHANGE_EMAIL_FOR_VERIFIED_LINKEDIN: 168,
  DATA_ROOM_MEMBER_NOT_AUTHORIZED_FOR_ACTION: 169,
  DATA_ROOM_NOT_FOUND: 170,
  DATA_ROOM_NODE_NOT_FOUND: 171,
  UNAUTHORIZED_BUYER_SUBSCRIPTION_ACCESS: 172,
  BUYER_SUBSCRIPTION_NOT_FOUND: 173,
  DATA_ROOM_MEMBER_NOT_FOUND: 174,
  UNAUTHORIZED_DEAL_ROOM_ACCESS: 175,
  DEAL_ROOM_NOT_FOUND: 176,
  CANNOT_TRANSFER_LISTING_TO_BROKER: 177,
  PRIVATE_VIEWER_IS_LEAD: 178,
  PRIVATE_VIEWER_IS_OWNER_OR_COOWNER: 179,
  // 180 is not using anymore
  DEAL_ROOM_COLLEAGUE_NOT_FOUND: 181,
  LEAD_CANNOT_BE_COLLEAGUE: 182,
  DATA_ROOM_QUESTION_NOT_FOUND: 183,
  DATA_ROOM_ANSWER_NOT_FOUND: 184,
  ENTERPRISE_NOT_FOUND: 185,
  DATA_ROOM_NODE_BULK_FORBIDDEN: 186,
  DEAL_ROOM_ARCHIVE_FORBIDDEN: 187,
  DEAL_ROOM_RESTORE_FORBIDDEN: 188,
  LEAD_NOTE_NOT_FOUND: 189,
  CANNOT_ADD_IM_TAG_FOR_FOLDER: 190,
  COLLEAGUE_CANNOT_BE_LEAD: 191,
  DATA_ROOM_MEMBER_EXIST: 192,
  BOSS_MODE_CANNOT_ENQUIRY: 193,
  DATA_ROOM_QUESTION_SUBJECT_NOT_FOUND: 194,
  DATA_ROOM_QUESTION_SUBJECT_INVALID: 195,
  FORBIDDEN_DATA_ROOM_ACTION: 196,
  INVALID_2FA: 197,
  UNIQUE_FIELD_MONGO_ERROR: 200,
  MONGO_ERROR: 201,
  AUTHENTICATION_ERROR: 202,
  AUTHORIZATION_ERROR: 203,
  VALIDATION_ERROR: 204,
  CAST_ERROR: 205,
  DEFAULT_ERROR: 206,
  UNAUTHORIZED_USER_ACCESS: 207,
  RFI_NOT_FOUND: 301,
  CANNOT_SUBMIT_RFI: 302,
  RFI_CATEGORY_NOT_FOUND: 303,
  DATA_ROOM_ARCHIVE_NOT_FOUND: 304,
  DATA_ROOM_ARCHIVE_IS_PROCESSING: 305,
  DATA_ROOM_ARCHIVE_NOT_POSSIBLE: 306,
  ENTERPRISE_MEMBER_NOT_AUTHORIZED_FOR_ACTION: 307,
  ENTERPRISE_MEMBER_NOT_FOUND: 308,
  FORBIDDEN_ENTERPRISE_ACTION: 309,
  ENTERPRISE_MEMBER_EXISTS: 310,
  CONTACT_NOT_FOUND: 311,
  UNAUTHORIZED_CONTACT_ACCESS: 312,
  CONTACT_EXISTS: 313,
  DEAL_ROOM_NOTE_NOT_FOUND: 314,
  CANNOT_CHANGE_LISTING_STAGE: 315,
  MAGIC_LINK_ENTITY_NOT_FOUND: 316,
  NDA_DOCUSIGN_TEMPLATE_IS_NOT_CONFIGURED: 317,
  FAILED_UPLOAD_ENCRYPTED_FILE: 318,
  SHAREABLE_LINK_INVALID_2FA_CODE: 319,
  SHAREABLE_LINK_NOT_FOUND: 320,
  SHAREABLE_LINK_INVALID_PASSWORD: 321,
  SHAREABLE_LINK_CONSUMER_NOT_FOUND: 322,
  SHAREABLE_LINK_REQUEST_NOT_FOUND: 323,
  DATA_ROOM_NDA_NOT_FOUND: 324,
  BROADCAST_MESSAGE_LEADS_NOT_FOUND: 325,
  RFI_INVALID_2FA_CODE: 326,
  DATA_ROOM_RFI_TEMPLATE_NOT_FOUND: 327,
  DATA_ROOM_RFI_TEMPLATE_EXISTS_WITH_SAME_NAME: 328,
  DASHBOARD_METRIC_NOT_FOUND: 329,
  ENTERPRISE_BUSINESS_UNIT_NOT_FOUND: 330,
  ACCOUNT_WITH_EMAIL_EXIST: 331,
  ACCOUNT_WITH_PHONE_NUMBER_EXIST: 332,
  DOCUSIGN_TEMPLATE_NOT_FOUND: 333,
  ENTERPRISE_LOCATION_NOT_FOUND: 334,
  ENTERPRISE_SENIORITY_NOT_FOUND: 335,
  DATA_ROOM_STORAGE_CAPACITY_EXCEEDED: 336,

  COULDNT_PARSE: 999,
} as const;

export const ERRORS_USER_FRIENDLY = {
  [ERROR_TYPES.NO_CONTACT_NUMBER]: 'noContactNumber',
  [ERROR_TYPES.NO_VERIFIED_MAIL]: 'noVerifiedEmail',
  [ERROR_TYPES.INVALID_CAPTCHA]: 'invalidCaptcha',
  [ERROR_TYPES.UNAUTHORIZED_FOR_ACTION]: 'unauthorizedForAction',
  [ERROR_TYPES.RESOURCE_ACCESS_UNAUTHORIZED]: '',
  [ERROR_TYPES.INVALID_RESOURCE_ID]: '',
  [ERROR_TYPES.JWT_UNAUTHORIZED]: '',
  [ERROR_TYPES.INVALID_JWT_TOKEN]: 'invalidJwtToken',
  [ERROR_TYPES.STRIPE_AUTHORIZATION_MIDDLEWARE]: '',
  [ERROR_TYPES.ACCOUNT_WITH_EMAIL_OR_PHONE_NUMBER_EXIST]:
    'accountWithEmailOrPhoneNumberExist',
  [ERROR_TYPES.UNAUTHORIZED_MESSAGE_ACCESS]: 'unauthorizedMessageAccess',
  [ERROR_TYPES.UNAUTHORIZED_SESSION_ACCESS]: 'unauthorizedSessionAccess',
  [ERROR_TYPES.UNAUTHORIZED_COMPANY_ACCESS]: 'unauthorizedCompanyAccess',
  [ERROR_TYPES.UNAUTHORIZED_LISTING_ACCESS]: 'unauthorizedListingAccess',
  [ERROR_TYPES.UNAUTHORIZED_LISTING_ENQUIRY_ACCESS]:
    'unauthorizedListingEnquiryAccess',
  [ERROR_TYPES.UNAUTHORIZED_LEAD_ACCESS]: 'unauthorizedLeadAccess',
  [ERROR_TYPES.UNAUTHORIZED_NOTIFICATION_ACCESS]:
    'unauthorizedNotificationAccess',
  [ERROR_TYPES.REFRESH_TOKEN_EXPIRED]: 'refreshTokenExpired',
  [ERROR_TYPES.BAD_BODY_VALIDATION_ERROR]: 'badBodyValidationError',
  [ERROR_TYPES.INVALID_CREDENTIALS]: 'invalidCredidentals',
  [ERROR_TYPES.SOCIAL_LOGIN_USER_CANT_RETRIEVED]: '121',
  [ERROR_TYPES.MISSING_FILE]: 'invalidFileError',
  [ERROR_TYPES.MISSING_FILENAME]: 'invalidFileError',
  [ERROR_TYPES.INVALID_FILENAME]: 'invalidFileError',
  [ERROR_TYPES.INVALID_MIMETYPE]: 'invalidMimeTypeError',
  [ERROR_TYPES.TWILIO_WRONG_CODE]: 'twilioWrongCode',
  [ERROR_TYPES.INVALID_VALUE_FOR_STEP]: '',
  [ERROR_TYPES.LISTING_WITH_CONTROLLED_INFORMATION_EXIST]:
    'listingWithControlledInformationExist',
  [ERROR_TYPES.CAN_CONFIRM_INTEREST_FROM_ACCEPTED_STATE]:
    'canConfirmInterestFromAcceptedState',
  [ERROR_TYPES.CAN_ACCEPT_OFFER_FROM_OFFERED_LEAD_STATE]:
    'canAcceptOfferFromOfferedLeadState',
  [ERROR_TYPES.CAN_REJECT_OFFER_FROM_OFFERED_LEAD_STATE]:
    'canRejecttOfferFromOfferedLeadState',
  [ERROR_TYPES.UNEXPECTED_LEAD_STATE_OPTION]: '',
  [ERROR_TYPES.BAD_LEAD_STATE_TRANSITION]: '',
  [ERROR_TYPES.NEW_LEAD_STATE_IS_FULL]: '',
  [ERROR_TYPES.CANT_SEND_DELETE_ACCOUNT_REQUEST]: '',
  [ERROR_TYPES.PHONE_NUMBER_VERIFIED]: 'phoneNumberVerifed',
  [ERROR_TYPES.EXIST_LEAD_FOR_LISTING_ENQUIRY]: '',
  [ERROR_TYPES.RESOURCE_NOT_FOUND]: '',
  [ERROR_TYPES.USER_DOCUMENT_NOT_FOUND]: 'userDocumentNotFound',
  [ERROR_TYPES.CHAT_MESSAGE_NOT_FOUND]: 'chatMessageNotFound',
  [ERROR_TYPES.USER_CONNECTION_NOT_FOUND]: 'userConnectionNotFound',
  [ERROR_TYPES.CHAT_SESSION_NOT_FOUND]: 'chatSessionNotFound',
  [ERROR_TYPES.CHAT_PARTICIPANT_NOT_FOUND]: 'chatSessionNotFound',
  [ERROR_TYPES.FILE_NOT_FOUND]: 'fileNotFound',
  [ERROR_TYPES.COMPANY_NOT_FOUND]: 'companyNotFound',
  [ERROR_TYPES.LISTING_NOT_FOUND]: 'listingNotFound',
  [ERROR_TYPES.LISTING_ENQUIRY_NOT_FOUND]: 'listingNotFound',
  [ERROR_TYPES.WORKFLOW_CONFIGURATION_NOT_FOUND]: 'listingNotFound',
  [ERROR_TYPES.LISTING_INVOICE_NOT_FOUND]: 'listingNotFound',
  [ERROR_TYPES.LEAD_NOT_FOUND]: 'leadNotFound',
  [ERROR_TYPES.INVALID_API_KEY]: 'invalidApiKeyMessage',
  [ERROR_TYPES.FILE_NAME_TOO_LONG]: 'fileNameTooLongMessage',
  [ERROR_TYPES.FILE_UPLOAD_FAILED]: 'fileUploadFailedMessage',
  [ERROR_TYPES.FILE_CORRUPTED]: 'fileCorruptedMessage',
  [ERROR_TYPES.NEED_SOCIAL_LOGIN]: 'needSocialLoginMessage',
  [ERROR_TYPES.PHONE_VERIFICATION_LIMIT_EXCEEDED]:
    'phoneVerificationLimitExceededMessage',
  [ERROR_TYPES.LISTING_SUBSCRIPTION_NOT_FOUND]: 'listingSubscriptionNotFound',
  [ERROR_TYPES.NOTIFICATION_NOT_FOUND]: 'notificationNotFound',
  [ERROR_TYPES.UNIQUE_FIELD_MONGO_ERROR]: 'uniqueFieldMongoError',
  [ERROR_TYPES.INVALID_2FA]: 'twoFAInvalidCode',
  [ERROR_TYPES.MONGO_ERROR]: '',
  [ERROR_TYPES.AUTHENTICATION_ERROR]: '',
  [ERROR_TYPES.VALIDATION_ERROR]: '',
  [ERROR_TYPES.CAST_ERROR]: '',
  [ERROR_TYPES.DEFAULT_ERROR]: '',
  [ERROR_TYPES.AUTHORIZATION_ERROR]: '',
  [ERROR_TYPES.UNAUTHORIZED_USER_ACCESS]: '',
  [ERROR_TYPES.COULDNT_PARSE]: 'couldntParse',
  [ERROR_TYPES.CANNOT_MAKE_ENQUIRY]: 'cannotMakeEnquiry',
  [ERROR_TYPES.EXTERNAL_LEAD_EXIST]: 'leadAlreadyExists',
  [ERROR_TYPES.BROKER_EXISTS]: 'brokerIsAlreadyRegistered',
  [ERROR_TYPES.DUPLICATE_CUSTOM_FILE_NAME]: 'duplicateCustomFileName',
  [ERROR_TYPES.WRONG_ENVELOPE_TEMPLATE_ID]: 'wrongTemplateId',
  [ERROR_TYPES.PRIVATE_VIEWER_IS_OWNER_OR_COOWNER]:
    'cannotInvitePotentialLeadIfOwnerOrCoowner',
  [ERROR_TYPES.LEAD_CANNOT_BE_COLLEAGUE]: 'cannotInviteLeadAsCoowner',
  [ERROR_TYPES.DATA_ROOM_MEMBER_EXIST]: 'dataRoomMemberAlreadyExists',
  [ERROR_TYPES.PRIVATE_VIEWER_IS_LEAD]: 'cannotInviteLeadAsPrivateViewer',
  [ERROR_TYPES.CANNOT_TRANSFER_LISTING_TO_BROKER]:
    'cannotTransferToLeadOrCoowner',
  [ERROR_TYPES.DEAL_ROOM_COLLEAGUE_NOT_FOUND]: 'dealRoomColleagueNotFound',
  [ERROR_TYPES.BROKER_DOESNT_HAVE_COMPANY]: 'brokerDoesntHaveCompany',
  [ERROR_TYPES.SPONSORED_LISTING_NOT_FOUND]: 'sponsoredListingNotFound',
  [ERROR_TYPES.ACCOUNTANT_NOT_FOUND]: 'accountNotFound',
  [ERROR_TYPES.CANNOT_CHANGE_EMAIL_FOR_VERIFIED_LINKEDIN]:
    'cannotChangeEmailForVerifiedLinkedin',
  [ERROR_TYPES.DATA_ROOM_MEMBER_NOT_AUTHORIZED_FOR_ACTION]:
    'dataRoomMemberNotAuthorized',
  [ERROR_TYPES.DATA_ROOM_NOT_FOUND]: 'dataRoomNotFound',
  [ERROR_TYPES.DATA_ROOM_NODE_NOT_FOUND]: 'dataRoomNodeNotFound',
  [ERROR_TYPES.UNAUTHORIZED_BUYER_SUBSCRIPTION_ACCESS]:
    'unathorizedBuyerSubscriptionAccess',
  [ERROR_TYPES.BUYER_SUBSCRIPTION_NOT_FOUND]: 'buyerSubscriptionNotFound',
  [ERROR_TYPES.UNAUTHORIZED_DEAL_ROOM_ACCESS]: 'unauthorizedDealRoomAccess',
  [ERROR_TYPES.DEAL_ROOM_NOT_FOUND]: 'dealRoomNotFound',
  [ERROR_TYPES.DATA_ROOM_MEMBER_NOT_FOUND]: 'dataRoomMemberNotFound',
  [ERROR_TYPES.DATA_ROOM_QUESTION_NOT_FOUND]: 'dataRoomQuestionNotFound',
  [ERROR_TYPES.DATA_ROOM_ANSWER_NOT_FOUND]: 'dataRoomAnswerNotFound',
  [ERROR_TYPES.ENTERPRISE_NOT_FOUND]: 'enterpriseNotFound',
  [ERROR_TYPES.DATA_ROOM_NODE_BULK_FORBIDDEN]: 'dataRoomBulkForbidden',
  [ERROR_TYPES.DEAL_ROOM_ARCHIVE_FORBIDDEN]: 'dealRoomArchiveForbidden',
  [ERROR_TYPES.DEAL_ROOM_RESTORE_FORBIDDEN]: 'dealRoomRestoreForbidden',
  [ERROR_TYPES.LEAD_NOTE_NOT_FOUND]: 'leadNoteNotFound',
  [ERROR_TYPES.CANNOT_ADD_IM_TAG_FOR_FOLDER]: 'cannotAddImTag',
  [ERROR_TYPES.COLLEAGUE_CANNOT_BE_LEAD]: 'colleagueCannotBeLead',
  [ERROR_TYPES.BOSS_MODE_CANNOT_ENQUIRY]: 'bossModeCannotBeLead',
  [ERROR_TYPES.DATA_ROOM_QUESTION_SUBJECT_NOT_FOUND]: 'questionSubjectNotFound',
  [ERROR_TYPES.DATA_ROOM_QUESTION_SUBJECT_INVALID]:
    'questionSubjectAlreadyExists',
  [ERROR_TYPES.FORBIDDEN_DATA_ROOM_ACTION]: 'forbiddenDataRoomAction',
  [ERROR_TYPES.RFI_NOT_FOUND]: 'rfiNotFound',
  [ERROR_TYPES.CANNOT_SUBMIT_RFI]: 'uploadAllBeforeSubmitting',
  [ERROR_TYPES.RFI_CATEGORY_NOT_FOUND]: 'uploadAllBeforeSubmitting',
  [ERROR_TYPES.DATA_ROOM_ARCHIVE_NOT_FOUND]: 'dataRoomArchiveNotFound',
  [ERROR_TYPES.DATA_ROOM_ARCHIVE_IS_PROCESSING]: 'dataRoomArchiveIsProcessing',
  [ERROR_TYPES.DATA_ROOM_ARCHIVE_NOT_POSSIBLE]: 'dataRoomArchiveNotPosibble',
  [ERROR_TYPES.ENTERPRISE_MEMBER_NOT_AUTHORIZED_FOR_ACTION]:
    'enterpriseMemberNotAuthorized',
  [ERROR_TYPES.ENTERPRISE_MEMBER_NOT_FOUND]: 'enterpriseMemberNotFound',
  [ERROR_TYPES.FORBIDDEN_ENTERPRISE_ACTION]: 'forbiddenEnterpriseAction',
  [ERROR_TYPES.ENTERPRISE_MEMBER_EXISTS]: 'enterpriseMemberAlreadyExist',
  [ERROR_TYPES.NDA_DOCUSIGN_TEMPLATE_IS_NOT_CONFIGURED]:
    'ndaDocusingNotConfigured',
  [ERROR_TYPES.CONTACT_NOT_FOUND]: 'contactNotFound',
  [ERROR_TYPES.UNAUTHORIZED_CONTACT_ACCESS]: 'unathorizedContactAccess',
  [ERROR_TYPES.CONTACT_EXISTS]: 'contactAlreadyExists',
  [ERROR_TYPES.DEAL_ROOM_NOTE_NOT_FOUND]: 'dealRoomNoteNotFound',
  [ERROR_TYPES.CANNOT_CHANGE_LISTING_STAGE]: 'cannotChangeListingStage',
  [ERROR_TYPES.MAGIC_LINK_ENTITY_NOT_FOUND]: 'magicLinkEntityNotFound',
  [ERROR_TYPES.FAILED_UPLOAD_ENCRYPTED_FILE]: 'encryptedFileUploadFailed',
  [ERROR_TYPES.SHAREABLE_LINK_INVALID_2FA_CODE]: 'shareableLinkInvalid2faCode',
  [ERROR_TYPES.SHAREABLE_LINK_NOT_FOUND]: 'shareableLinkNotFound',
  [ERROR_TYPES.SHAREABLE_LINK_INVALID_PASSWORD]: 'shareableLinkInvalidPassword',
  [ERROR_TYPES.SHAREABLE_LINK_CONSUMER_NOT_FOUND]:
    'shareableLinkConsumerNotFound',
  [ERROR_TYPES.SHAREABLE_LINK_REQUEST_NOT_FOUND]:
    'shareableLinkRequestNotFound',
  [ERROR_TYPES.DATA_ROOM_NDA_NOT_FOUND]: 'dataRoomNdaNotFound',
  [ERROR_TYPES.BROADCAST_MESSAGE_LEADS_NOT_FOUND]:
    'broadcastMessageLeadsNotFound',
  [ERROR_TYPES.RFI_INVALID_2FA_CODE]: 'rfiInvalid2faCode',
  [ERROR_TYPES.DATA_ROOM_RFI_TEMPLATE_NOT_FOUND]: 'rfiNotFound',
  [ERROR_TYPES.DATA_ROOM_RFI_TEMPLATE_EXISTS_WITH_SAME_NAME]:
    'templateWithThisNameAlreadyExists',
  [ERROR_TYPES.ACCOUNT_WITH_EMAIL_EXIST]: 'accountWithEmailExist',
  [ERROR_TYPES.ACCOUNT_WITH_PHONE_NUMBER_EXIST]: 'accountWithPhoneNumberExist',

  [ERROR_TYPES.DASHBOARD_METRIC_NOT_FOUND]: 'dashboardMetricNotFound',
  [ERROR_TYPES.ENTERPRISE_BUSINESS_UNIT_NOT_FOUND]:
    'enterpriseBusinessUnitNotFound',

  [ERROR_TYPES.DOCUSIGN_TEMPLATE_NOT_FOUND]: 'docusignTemplateNotFound',
  [ERROR_TYPES.ENTERPRISE_LOCATION_NOT_FOUND]: 'enterpriseLocationNotFound',
  [ERROR_TYPES.ENTERPRISE_SENIORITY_NOT_FOUND]: 'enterpiseSenorityNotFound',

  [ERROR_TYPES.DATA_ROOM_STORAGE_CAPACITY_EXCEEDED]: 'dataRoomCapacityExceeded',
};

export type ErrorMessageValue = ObjectValues<typeof ERROR_TYPES>;

export type ErrorMessageKey = keyof typeof ERROR_TYPES;

export const SUCCESS_MESSAGES = {
  FILE_DELETED: 'fileDeletedSuccessfully',
  FILE_NAME_UPDATED: 'updatedFileName',
  FILE_UPLOADED: 'fileUploadedSuccessfully',
  REMOVED_FROM_WATCHLIST: 'removeFromYourWatchlist',
  REFER_FRIEND: 'referAFriendSuccessMessage',
  REVERT_ACCOUNT_DELETION: 'successfullyRevertedAccountDeletion',
  VERIFIED_EMAIL: 'successfullyVerifiedEmail',
  FORGOT_PASSWORD: 'forgotPasswordSuccess',
  CHAGED_PASSWORD: 'changePasswordSuccess',
  CONTACT_US: 'thankYouForContactingUs',
  TRIED_ENQUIRY: 'hasTriedEnquiry',
  REGISTERED_INTEREST: 'successfullyRegisteredInterest',
  MOVED_TO_BLOCKED: 'successfullyBlocked',
  ADDED_TO_WATCHLIST: 'listingAddedToWatchlist',
  WITHDRAWN_INTEREST: 'interestWithdrawnSuccessfully',
  OFFER_ACCEPTED: 'offerAccepted',
  OFFER_REJECTED: 'offerRejected',
  UNPAUSED_LISTING: 'successfullyUnpausedListing',
  PAUSED_LISTING: 'successfullyPausedListing',
  MARKED_AS_SOLD: 'successfullyMarkedAsSold',
  UPDATED_WORKFLOW_CONFIGURATION: 'successfullyUpdatedWorkflowConfiguration',
  DELETED_ACCOUNT: 'successfullyDeletedAccount',
  PHONE_NUMBER_VERIFIED: 'yourPhoneNumberHasBeenVerified',
  CHECK_PHONE_INBOX: 'pleaseCheckMessageInboxOnYourPhone',
  PACHED_LISTING: 'patchListingSuccess',
  PACHED_USER: 'patchUserSuccess',
  IMAGE_UPLOADED: 'imageUploaded',
  IMAGE_DELETED: 'imageDeleted',
  SAVED_AS_DRAFT: 'savedListingAsDraftSuccess',
  SUBSCRIBED_TO_NEWSLETTER: 'subscribedToNewsletter',
  UNSUBSCRIBED_FROM_NEWSLETTER: 'unsubscribedFromNewsletter',
  NDA_CONNECTED: 'ndaConnected',
  LISTING_PAY: 'payListingSuccess',
  LISTING_PRIVATE: 'privateListingSuccess',
  EDIT_DEAL: 'successfullyEditDeal',
  DELETED_LEAD: 'successfullyDeletedLead',
  WITHDRAW_LEAD: 'successfullyWithdrawnLead',
  CHANGE_LEAD_STATE: 'successfullyLeadStateChanged',
  UNSUBSCRIBED: 'successfullyUnsubscribed',
  CREAT_BRAND: 'successfullyCreatedBrand',
  EDIT_BRAND: 'successfullyEditedBrand',
  CREATE_MEMBER: 'successfullyCreatedMember',
  EDIT_MEMBER: 'successfullyEditedMember',
  CREATE_CONTACT: 'successfullyCreatedContact',
  UPDATE_CONTACT: 'successfullyUpdatedContact',
  DELETE_CONTACT: 'successfullyDeletedContact',
  LOCKED_PREMIUM_FEATURES: 'successfullyLockedFeatures',
  UNLOCKED_PREMIUM_FEATURES: 'successfullyUnlockedFeatures',
} as const;
